/* global InnerScreen, QuestionAnswer */
"use strict";

($dt => {
	
	$dt.TopicGrid.Functions = {
		...$dt.TopicGrid.Functions,
		dev_startup: () => {},
		on_nothing: () => {},
		convert_egalaxy_date: date_input => {
			const matches = /^([0-9]{4,4})-([0-9]{2,2})-([0-9]{2,2})$/.exec(date_input);
			return matches && matches.length > 3 ? `${matches[2]}-${matches[3]}-${matches[1]}` : date_input;
		},
		clean_egalaxy_time: time_input => {
			const matches = /^([0-9]{1,2}\:[0-9]{2,2})(\:[0-9]{2,2})$/.exec(time_input);
			return matches && matches.length > 2 ? matches[1] : time_input;
		},
		make_date_string_into_datetime_string: (date_only_input, optional_time) => {
			if (!optional_time) {
				optional_time = '00:00:00';
			}
			let matches = /^(?<year>[0-9]{4,4})-(?<month>[0-9]{2,2})-(?<day>[0-9]{2,2})$/.exec(date_only_input);
			if (!matches) {
				matches = /^(?<month>[0-9]{2,2})-(?<day>[0-9]{2,2})-(?<year>[0-9]{4,4})$/.exec(date_only_input);
			}
			if (matches) {
				const match_groups = matches.groups;
				return match_groups.year + '-' + match_groups.month + '-' + match_groups.day + ' ' + optional_time;
			}
			return date_only_input + ' ' + optional_time;
		},
		format_money: (float_input, dollars_only) => {
			const options = { style: 'currency', currency: 'USD' };
			if (dollars_only) {
				options.minimumFractionDigits = 0;
			}
			return new Intl.NumberFormat('en-US', options).format(float_input);
		},
		repaint_elem: elem => {
			elem.style.paddingBottom = '1px';
			setTimeout(() => {
				elem.style.paddingBottom = null;
			}, 150);
		},
		create_inner_screen: (inner_elem, index) => {
			const inner_screen = new InnerScreen(inner_elem, index);
			return inner_screen;
		},
		create_question_answer: (index, question, answer) => {
			return new QuestionAnswer(index, question, answer);
		},
		calculate_chaperones: (num_children, topic) => {
			const num_chaperones_required = num_children / topic.chaperones.number_of_children_per_chaperone;
			return Math.ceil(num_chaperones_required);
		},
		get_topic_type_variant: (topic_type_key, topic_type_variants) => {
			return topic_type_variants.find(ttype => { return ttype.key === topic_type_key; });
		},
		get_total_price_for_target_by_topic: (current_topic, scheduling_info, selected_date_obj) => {
			const { get_price_for_target } = $dt.TopicGrid.Functions;
			const { children, paid_adults, addon } = current_topic;
			const { reservation_attendees, children_attendees, paid_adult_attendees, addon_attendees } = scheduling_info;
			let children_price = 0, paid_adults_price = 0, addon_price = 0;	
			const reservation_price = get_price_for_target(current_topic.price, current_topic.price_schedule, selected_date_obj);
			if (children && children.children_price) {
				children_price = get_price_for_target(children.children_price, children.price_schedule, selected_date_obj);
			}
			if (paid_adults && paid_adults.paid_adults_price) {
				paid_adults_price = get_price_for_target(paid_adults.paid_adults_price, paid_adults.price_schedule, selected_date_obj);
			}
			if (addon && addon.price) {
				addon_price = get_price_for_target(addon.price, addon.price_schedule, selected_date_obj);
			}
			let total = reservation_attendees * reservation_price;
			total += children_attendees * children_price;
			total += paid_adult_attendees * paid_adults_price;
			total += addon_attendees * addon_price;
			return total;
		},
		get_price_for_target: (default_price, price_schedule, target_date_obj) => {
			let price = default_price;
			if (price_schedule && price_schedule.length > 0) {
				price_schedule.forEach(p => {
					if (target_date_obj >= new Date(p.start_date + ' 00:00:00') && target_date_obj < new Date(p.end_date + ' 23:59:59')) {
						price = p.price;
					}
				});
			}
			return price;
		},
		get_formatted_price_for_target: (default_price, price_schedule, target_date_obj) => {
			return $dt.TopicGrid.Functions.format_money(
				$dt.TopicGrid.Functions.get_price_for_target(default_price, price_schedule, target_date_obj)
			);
		},
		toggle_variant_visibility: (visible_variant, topic_type_variants) => {
			topic_type_variants.forEach(test_variant => {
				if (test_variant.key !== visible_variant.key) {
					test_variant.select_attendees_elem.classList.remove('active-input');
				}
			});
			visible_variant.select_attendees_elem.classList.add('active-input');
		},
		topic_type_requires_class_grade: (topic) => {
			const { TOPIC_TYPES } = $dt.TopicGrid.Constants;
			const required_types = [ TOPIC_TYPES.ONSITE, TOPIC_TYPES.SCIENCE_TO_GO ];
			return required_types.includes(topic.topic_type);
		},
		topic_type_requires_dynamic_questions: (topic) => {
			const { TOPIC_TYPES } = $dt.TopicGrid.Constants;
			const required_types = [ TOPIC_TYPES.ONSITE, TOPIC_TYPES.SCIENCE_TO_GO, TOPIC_TYPES.ONSITE_SELF_GUIDED, TOPIC_TYPES.COMMUNITY ];
			return required_types.includes(topic.topic_type);
		},
		apply_form_validation_to_summary: (formContainer, form, errors) => {
			const summary = document.createElement('ul');
			summary.classList.add('d3df_invalid_list');
			
			const summaryItem = document.createElement('li');
			summaryItem.classList.add('d3df_invalid_list_item');
			summaryItem.textContent = form.errorSummaryMessage;
			
			for (let f = 0; f < errors.length; f++) {
				const err = errors[f];
				const field = formContainer.querySelector('.d3df_field_' + err.Key);
				if (field) {
					field.classList.add('d3df_invalid');
					switch (form.errorMessageType) {
						case 'inline':
							const inline = field.querySelector('.d3df_error_message');
							inline.innerHTML = err.Message;
							break;
						case 'bottom':
							const bottom = document.createElement('li');
							bottom.setAttribute('data-key', err.Key);
							bottom.classList.add('d3df_invalid_list_item');
							bottom.innerHTML = err.Message;
							summary.appendChild(bottom);
							break;
						case 'summaryBottom':
							summary.insertBefore(summaryItem, summary.childNodes[0] || null);
							break;
					}
				} else {
					if (err.Message.length > 0) {
						const invalid = document.createElement('li');
						invalid.setAttribute('data-key', err.Key);
						invalid.classList.add('d3df_invalid_list_item');
						invalid.innerHTML = err.Message;
						summary.appendChild(invalid);
					}
				}
			}

			if (summary.firstChild) {
				const errSummary = formContainer.querySelector('.d3df_simple_error_summary');
				if (errSummary) {
					errSummary.innerHTML = '';
					errSummary.append(summary);
				}
			}
		},
		maybe_include_addon_summary_line: (current_topic, scheduling_info, addon_price, output_money) => {
			let reserved_html = '';
			if (current_topic.addon && scheduling_info.addon_attendees !== false) {
				if (typeof(output_money) === 'undefined') {
					output_money = $dt.TopicGrid.Functions.format_money;
				}
				const { plu_name } = current_topic.addon;

				reserved_html =
					`<tr><td>${plu_name}</td><td>${scheduling_info.addon_attendees} ${output_money(addon_price * scheduling_info.addon_attendees)}</td></tr>`;
			}
			return reserved_html;
		},
		consoleLog: (...args) => {
			if ($dt.is_dev) {
				// Use console.log with cyan prefix "[TopicGrid]"
				console.log('%c[TopicGrid]', 'color: cyan;', ...args);
			}
		}
	};

	/* Dev Mode */
	if (!$dt.is_dev) {
		// Catch just in case the code below is left uncommented which we don't want compiled in prod.
		return;
	}
	/*
	$dt.TopicGrid.Functions.dev_startup = (controller, block) => {
		const { create_question_answer } = $dt.TopicGrid.Functions;
		// Preset anon contact info
		const { contact_info, scheduling_info } = block;
		//contact_info.anon = true;
		if (contact_info.anon) {
			contact_info.firstname = 'LJ';
			contact_info.lastname = 'Johnson';
			contact_info.email = 'test@test.com';
			contact_info.phone = '949-555-1212';
			contact_info.street_address1 = '55 12th St.';
			contact_info.city = 'Irvine';
			contact_info.state = 'CA';
			contact_info.zip = '92618';
			contact_info.school = 26184;
			//contact_info.school_name = '';
		}

		// Grade
		scheduling_info.class_grade = '11';

		// Question Answers
		scheduling_info.class_info_questions = [];
		for (let question_index = 0; question_index < 5; question_index++) {
			scheduling_info.class_info_questions.push(
				create_question_answer(question_index, 'Question ' + (question_index + 1), 'Answer ' + (question_index + 1))
			);
		}

		// Attendees
		scheduling_info.reservation_attendees = 1;
		scheduling_info.children_attendees = 15;
		scheduling_info.chaperone_attendees = 0;
		scheduling_info.paid_adult_attendees = 0;

		// Date select
		//scheduling_info.selected_date = '2025-04-02';
		//scheduling_info.selected_event_id = 439216;
		//scheduling_info.selected_time = '09:00:00';

		// Notes
		scheduling_info.notes = 'This is a TEST order, please ignore. CC Deposit Payment Is Simulated (Do Not Attempt to Refund)';
		
		// Skip To Screen
		controller.OpenTopicDetails(block, controller.FindTopic(25505), { outer: 0, inner: 3 });
	};
	*/

})(window.d3_wp_themejs);
